/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputBeginWebAuthnVerificationRequest
 */
export interface InputBeginWebAuthnVerificationRequest {
    /**
     * Challenge token from auth flow
     * @type {string}
     * @memberof InputBeginWebAuthnVerificationRequest
     */
    challenge: string;
}

/**
 * Check if a given object implements the InputBeginWebAuthnVerificationRequest interface.
 */
export function instanceOfInputBeginWebAuthnVerificationRequest(value: object): boolean {
    if (!('challenge' in value)) return false;
    return true;
}

export function InputBeginWebAuthnVerificationRequestFromJSON(json: any): InputBeginWebAuthnVerificationRequest {
    return InputBeginWebAuthnVerificationRequestFromJSONTyped(json, false);
}

export function InputBeginWebAuthnVerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputBeginWebAuthnVerificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': json['challenge'],
    };
}

export function InputBeginWebAuthnVerificationRequestToJSON(value?: InputBeginWebAuthnVerificationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'challenge': value['challenge'],
    };
}

